import React from 'react';
import { useSelector } from 'react-redux';
import SystemDataService from '../../Services/SystemDataService';
import ImageComponent from '../../Utils/Image/image-component';
import { ButtonPrimary, ButtonSecondary } from '../../Utils/Buttons/button-component';
import ContentSection from '../../Utils/Content/content-section-component';

export default function LocationsMiddleSection({ insightsData, caseStudyData }) {
  const systemData = useSelector((s) => s.systemData || {});
  const { dir, links = [], language } = systemData;

  const phone = SystemDataService.byLabel(links, 'Phone') || {};
  const email = SystemDataService.byLabel(links, 'Email') || {};

  const renderContent = (text) => {
    if (!text) return null;
    return text.split('\n\n').map((para, idx) => (
      <p key={idx} className="leading-relaxed mb-6 last:mb-0">
        {para}
      </p>
    ));
  };

  return (
    <section className="w-full bg-white dark:bg-neutral-950 font-assistant overflow-hidden">

      {/* --- SECTION 1: LOCAL INSIGHTS (The Editorial Grid) --- */}
      {insightsData && (
        <div className="relative py-24 lg:py-40 px-6 max-w-7xl mx-auto">
          {/* Background Decorative Accent: Massive Outlined Text */}
          <div className="absolute top-10 left-0 opacity-[0.03] dark:opacity-[0.07] pointer-events-none select-none">
            <span className="text-[15rem] font-black uppercase er leading-none">
              {language === 'he' ? 'מידע' : 'INSIGHT'}
            </span>
          </div>

          <div className={`relative z-10 flex flex-col lg:flex-row gap-12 lg:gap-24 items-center ${dir === 'rtl' ? 'lg:flex-row-reverse' : ''}`}>

            {/* Heading Area: Vertical Tension */}
            <div className="w-full lg:w-5/12 space-y-8">
              <h2 className="text-6xl lg:text-7xl font-black text-neutral-900 dark:text-white leading-[0.85] er uppercase">
                {insightsData.title}
              </h2>

              <div className="pt-4 max-w-md mx-auto">
                <ButtonSecondary
                  href={phone?.url}
                  size="lg"
                  className="!rounded-2xl shadow-2xl shadow-secondary-500/20 uppercase font-black tracking-[0.2em] text-xs px-10"
                >
                  {language === 'he' ? 'ייעוץ טלפוני' : 'Consult Technician'}
                </ButtonSecondary>
              </div>
            </div>

            {/* Content Area: Clean Professional Column */}
            <div className="w-full lg:w-7/12">
              <div className="text-xl lg:text-3xl text-neutral-500 dark:text-neutral-400 font-medium leading-tight space-y-2  italic">
                {renderContent(insightsData.content)}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --- SECTION 2: CASE STUDY (The Blueprint Spotlight) --- */}
      {caseStudyData && (
        <div className="w-full py-6">
          <div className="max-w-8xl mx-auto overflow-hidden ">
            <ContentSection
              backgroundImage={caseStudyData.image}
              overlayOpacity="bg-black/40"
              className=" flex items-center"
            >
              <div className={`max-w-2xl bg-white/10 dark:bg-black/20 backdrop-blur-3xl p-16 rounded-[40px] border border-white/20 shadow-2xl ${dir === 'rtl' ? 'mr-auto' : 'ml-auto'}`}>
                <div className="space-y-6">
                  <h3 className="text-4xl lg:text-6xl font-black text-primary-950 leading-tight uppercase er">
                    {caseStudyData.title}
                  </h3>
                  <div className="text-lg lg:text-xl  text-primary-950font-medium leading-relaxed line-clamp-6">
                    {renderContent(caseStudyData.content)}
                  </div>
                  <div className="pt-4">
                    <ButtonPrimary
                      href={email?.url}
                      size="lg"
                      variant="outline"
                      className="!rounded-full border-white text-white hover:bg-white hover:text-black uppercase font-black tracking-widest text-xs px-12 transition-all"
                    >
                      {language === 'he' ? 'צפה בפרטי הפרויקט' : 'Case Study Details'}
                    </ButtonPrimary>
                  </div>
                </div>
              </div>
            </ContentSection>
          </div>
        </div>
      )}
    </section>
  );
}